import * as actionsTypes from './actionsTypes';

const initialState = {
  surveyUserForm: {},
  isLoading: false,
  error: "",
  //surverUserFormError: "",
  isLoadingSurveyUserForm: false,
  sendSurveyFormFaild: false,
  isSendSurveyForm: false,
  // Nuevos estados para detalles de encuesta
  surveyUserFormDetail: null,
  isLoadingSurveyUserFormDetail: false,
  surveyUserFormDetailError: "",
}

export default function surveyUserFormReducer(state = initialState, action){
  switch (action.type) {
    case actionsTypes.FETCH_SURVEY_USER_FORM_REQUEST:
      return {...state, isLoading: action.payload}
    case actionsTypes.FETCH_SURVEY_USER_FORM_SUCCESS:
      return {...state, surveyUserForm: action.payload};
    case actionsTypes.FETCH_SURVEY_USER_FORM_FAILURE:
      return { ...state, error: action.payload };
    //Form
    case actionsTypes.SAVE_USER_ANSWERS_REQUEST:
      return {...state, isLoadingSurveyUserForm: action.payload}
    //case actionsTypes.SAVE_USER_ANSWERS_SUCCESS:
    //  return {...state, surveyUserForm: action.payload};
    case actionsTypes.SAVE_USER_ANSWERS_FAILURE:
      return { ...state, error: action.payload };
    case actionsTypes.SEND_SURVEY_USER_FORM:
      return {...state, isSendSurveyForm: action.payload}
    case actionsTypes.SEND_SURVEY_USER_FORM_FAILD:
      return { ...state, sendSurveyFormFaild: action.payload };
    // Nuevos casos para manejar detalles de encuesta
    case actionsTypes.FETCH_SURVEY_USER_FORM_DETAIL_REQUEST:
      return {...state, isLoadingSurveyUserFormDetail: action.payload}
    case actionsTypes.FETCH_SURVEY_USER_FORM_DETAIL_SUCCESS:
      return {...state, surveyUserFormDetail: action.payload, surveyUserFormDetailError: ""};
    case actionsTypes.FETCH_SURVEY_USER_FORM_DETAIL_FAILURE:
      return { ...state, surveyUserFormDetailError: action.payload };
    case actionsTypes.CLEAR_SURVEY_USER_FORM_DETAIL:
      return { ...state, surveyUserFormDetail: null, surveyUserFormDetailError: "" };
    default:
      return state;
  }
}